<!-- AI診断　注意事項 -->
<template>
  <div class="caution-list-wrapper">
    <!-- 注意事項コンテナここから -->
    <div class="note">
      <div class="section1">
        <div class="font-adjust-bold section1-left">
          <display-text :text="$t('notes.aiDiseasePredictionNeeds')" />
        </div>
        <div class="section1-right">
          <div class="font-adjust-bold required-factors">
            {{ $t("notes.requiredFactors") }}
          </div>
          <div class="font-adjust-normal">
            {{ $t("bloodTestResult.fastingBloodSugarLevel")
            }}{{ $t("common.marks") }}
            {{ $t("bloodTestResult.totalCholesterol")
            }}{{ $t("common.marks") }}
            {{ $t("bloodTestResult.triglycerideDetail")
            }}{{ $t("common.marks") }} {{ $t("bloodTestResult.hdlcholesterol")
            }}{{ $t("common.marks") }} {{ $t("bloodTestResult.ldlCholesterol")
            }}{{ $t("common.marks") }} {{ $t("bloodTestResult.hemoglobin")
            }}{{ $t("common.marks") }} {{ $t("bloodTestResult.serumCreatinine")
            }}{{ $t("common.marks") }} {{ $t("bloodTestResult.γGtp")
            }}{{ $t("common.marks") }} {{ $t("bloodTestResult.AST")
            }}{{ $t("common.marks") }} {{ $t("bloodTestResult.ALT")
            }}{{ $t("common.marks") }}
            {{ $t("bloodTestResult.urinaryProtein") }}
          </div>
          <div
            v-text="$t('notes.doYouHaveTheseItems')"
            class="font-adjust-bold"
          />
          <radio-button class="radio-button" :value="check2" @toggle="toggle" />
        </div>
      </div>

      <!-- 現在の疾病について -->
      <div class="section2">
        <p v-text="$t('notes.yourCurrentDiseases')" class="font-adjust-bold" />
        <display-text
          :text="$t('notes.ifYouHaveTheDiseasesBelow')"
          class="font-adjust-normal"
        />
        <buttons
          :diseasesData="diseasesData"
          :disableDiseases="getDisableDiseases"
          @toggelActiveDiseaseHistory="toggelActiveDiseaseHistory"
        />
      </div>

      <div class="section3">
        <p
          v-text="$t('notes.aboutPredictionResults')"
          class="font-adjust-bold"
        />
        <display-text
          :text="$t('notes.thePredictionResultDoesNot')"
          class="font-adjust-normal"
        />
      </div>

      <!--料金についての文言追加 -->
      <div class="section4">
        <!-- クレジットカードについて -->
        <div>
          <p v-text="$t('notes.payment')" class="font-adjust-bold" />
          <display-text
            :text="$t('notes.paymentByCreditCard')"
            class="font-adjust-normal"
          />
          <img
            :src="credit_card_icon"
            alt="支払い可能なクレジットカード一覧"
            class="credit-card-icon"
          />
        </div>
        <!--クーポンの使用について -->
        <div>
          <!--TODO クーポンコードを使用した支払いについての説明文を追加する -->
        </div>
      </div>

      <!--チェックボタン・同意ボタン-->
      <div class="checkButton-container">
        <div>
          <check-button
            @toggleCheck="toggleCheck"
            :class="{ active: check }"
            data-test="agreement-button"
          />
        </div>
        <div>
          <p v-text="$t('notes.agree')" />
        </div>
      </div>

      <!--　疾病開始予測ボタン -->
      <next-button
        :disabled="!isDisable"
        @click="onClickStartButton"
        :label="$t('notes.startAiPrediction')"
      />

      <!-- レポートサンプルのリンク -->
      <div class="linkText-adjust">
        <a
          href="https://mirai.karadakarada.com/selvycheckup/"
          target="_blank"
          >{{ $t("aiPredictionReport.seeASampleOfDiagnosis") }}</a
        >
      </div>
    </div>
    <!-- 注意事項コンテナここまで -->

    <!--TODO スマホdeドック CSS修正 -->
    <div class="sumaho-de-dock">
      <img
        :src="kddiSource"
        alt="「おウチでできる血液検査キット」スマホdeドック"
      />
      <a href="https://www.smartkensa.com/" target="_blank">{{
        $t("aiPredictionReport.apply")
      }}</a>
    </div>
  </div>
</template>

<script>
import HeaderTitle from "../design/HeaderTitleSlot";
import displayText from "../components/atoms/displayValue/DisplayText";
import Buttons from "../components/molecules/Notes/Buttons";
import CheckButton from "../components/atoms/Notes/CheckButton";
import RadioButton from "../components/molecules/Notes/RadioButton";
import NextButton from "../components/atoms/NextButton";

import kddi from "../../static/kddi.png";
import kddi_en from "../../static/kddi_en.png";
import credit_card_icon from "../../static/credit_card_icon.png";

export default {
  data() {
    return {
      // ボタン制御用変数
      check: false,
      check2: false,

      // 画像データのパス
      kddi: kddi,
      kddi_en: kddi_en,
      credit_card_icon: credit_card_icon,

      diseasesData: {
        DM: false,
        LIVER: false,
        BREAST: false,
        DEMENTIA: false,
        HEART: false,
        STOMACH: false,
        COLORECTAL: false,
        LUNG: false,
        STROKE: false,
        PROSTATE: false,
      },
      disableDiseases: {
        DM: false,
        LIVER: false,
        BREAST: false,
        DEMENTIA: false,
        HEART: false,
        STOMACH: false,
        COLORECTAL: false,
        LUNG: false,
        STROKE: false,
        PROSTATE: false,
      },
    };
  },
  components: {
    displayText,
    Buttons,
    CheckButton,
    RadioButton,
    HeaderTitle,
    NextButton,
  },
  methods: {
    //TODO 命名の変更
    toggleCheck() {
      this.check = !this.check;
    },
    toggle() {
      this.check2 = !this.check2;
    },
    toggelActiveDiseaseHistory(index) {
      this.$set(this.diseasesData, index, !this.diseasesData[index]);
    },
    onClickStartButton() {
      this.$emit("setModel", this.diseasesData);
      this.$emit("increment");
    },
  },
  computed: {
    kddiSource() {
      let locale =
        (window.navigator.languages && window.navigator.languages[0]) ||
        window.navigator.language ||
        window.navigator.userLanguage ||
        window.navigator.browserLanguage;
      if (locale === "ja") {
        return this.kddi;
      } else {
        return this.kddi_en;
      }
    },
    isDisable() {
      return this.check && this.check2;
    },
    getDisableDiseases() {
      const gender = Number(this.$store.state.users.gender);
      switch (gender) {
        case 1: // 男性
          this.disableDiseases.BREAST = true;
          break;
        case 2: // 女性
          this.disableDiseases.PROSTATE = true;
          break;
      }
      return this.disableDiseases;
    },
  },
};
</script>

<style scoped>
.caution-list-wrapper {
  width: 65vw;
  align-content: center;
  align-items: center;
  margin: 0 auto;
}
/* タイトル調整 */
.headerTitle-label {
  font-size: 30px;
  margin: 0 auto;
  margin-right: auto;
  margin-left: auto;
}

/* 文章を構成するフォント用 */
.font-adjust-bold {
  font-size: 16px;
  text-align: left;
  line-height: 30px;
  font-weight: bold;
}
.required-factors::before {
  content: "■";
}
.font-adjust-normal {
  font-size: 16px;
  text-align: left;
  line-height: 30px;
}

/* リンクテキスト用 */
.linkText-adjust {
  margin-top: 30px;
  margin-bottom: 10px;
}
.sumaho-de-dock-container {
  border: 2px solid #92ccef;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  padding: 40px;
}
.note {
  border: 2px solid #d8e0e7;
  border-radius: 10px;
  padding: 20px;
  margin: 0 auto;
  width: 100%;
}

.section1 {
  display: grid;
  gap: 20px;
  width: 100%;
}
@media screen and (max-width: 1239px) {
  .section1 {
    grid-template-columns: 1fr;
  }
}
@media screen and (min-width: 1240px) {
  .section1 {
    grid-template-columns: 1fr 1fr;
  }
}
.section1-right,
.section1-left,
.font-adjust-normal {
  width: 100%;
}

.section2,
.section3,
.section4 {
  margin-top: 40px;
}

.checkButton-container {
  margin-top: 100px;
}

.check-button {
  display: flex;
  justify-content: center;
  line-height: 40px;
}

.active {
  background-color: #c5d7ef !important;
}

.sumaho-de-dock {
  margin-top: 40px;
  border: 2px solid #92ccef;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  padding: 20px;
}
.sumaho-de-dock > img {
  margin: auto;
  width: 60%;
  object-fit: cover;
}
.credit-card-icon {
  margin: auto;
  width: 70%;
  object-fit: cover;
}
</style>
